<template>
  <v-flex xs12 sm12>
    <v-card flat color="transparent">
      <v-layout row justify-center>
        <v-flex xs8 sm8 v-if="user">
          <v-layout row wrap justify-center fill-height align-center>
            <v-flex xs7 style="position: relative;">
              <v-img
                class="size-image-avatar"
                :src="user.image"
                :style="`border-radius: 50%; border: 5px solid `+ user.color + ';'"
              >
              </v-img>
              <v-layout align-end justify-center row>
                <img
                  height="40px"
                  width="40px"
                  src="@/assets/cumple.gif"
                  v-if="user.is_birthday"
                  style="position: absolute; bottom: -1rem; left: 4.4rem; "
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row mt-4>
        <v-flex xs12 sm12>
          <p class="grey-security text-xs-center font-weight-bold text-18-security mb-0"
          >{{user.full_name}}</p>

          <p class="text-14-security grey-security text-xs-center mb-0"
          >{{user.position}}</p>

          <p class="text-14-security grey-security font-weight-bold text-xs-center mb-0"
          >{{user.company}}</p>
        </v-flex>
      </v-layout>

      <v-layout row mt-3 justify-center>
        <v-flex xs10 sm10> 
          <p class="tff-center-item text-13-security grey-security mb-0">
            <img class="material-icons" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/map-marker.svg" style="width: 17px" alt="address">
            <span class="pl-1">{{user.address}}</span>
          </p>
          <p class="tff-center-item text-13-security grey-security mb-0">
            <a v-bind:href="`tel:${user.phone}`" class="email_phone tff-center-item">
               <img class="material-icons" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/phone.svg" style="width: 17px" alt="phone">
              <span class="pl-1">{{user.annexed}}</span>
            </a>
          </p>
          <p class="tff-center-item text-13-security grey-security mb-0">
            <a v-bind:href="`mailto:${user.email}`" class="email_phone tff-center-item">
              <img class="material-icons" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/email-outline.svg"  style="width: 17px" alt="email">
              <span class="pl-1">{{ " " + user.email }}</span>
            </a>
          </p>
          <p v-show="user.birthday" class="tff-center-item text-13-security grey-security mb-0">
            <img  grey-security clas="colorp" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/cake-variant.svg"  style="width: 17px" alt="cake">
            <span class="pl-1">{{user.birthday}}</span>
          </p>
        </v-flex>
      </v-layout>


      <v-layout row mt-4>
        <v-flex xs12>
          <div class="text-xs-center">
            <v-btn
              color="#28385C"
              class="white--text"
              round
              @click="handleCompanyChart()"
            >
              Organigrama
            </v-btn>

            <v-btn
              color="grey darken-2"
              v-if="currentUser.role.includes('super_admin') || currentUser.role.includes('admin')" 
              round
              class="white--text"
              @click="changeUser"
              :disabled="user.full_legal_number == 'sin rut'"
            >Ver como</v-btn>

            <v-btn
              color="#505789"
              class="white--text"
              round
              :href="`https://teams.microsoft.com/l/chat/0/0?users=${user.email}`"
              target="_blank"
            >
              <img src="@/assets/chat_teams.png" style="height: 1.5em;" />
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    currentUser: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions("user", ["fetchCurrentUser", "fetchUser", "fetchCurrentUserParents", "fetchUserMessages", "showHideCompanyChart"]),
    ...mapActions("benefits", ["fetchBenefits"]),
    ...mapActions("api_menu", ["fetchMenu", "fetchFooterMenu"]),
    ...mapActions("menus", ["fetchMenuMobile"]),
    ...mapActions("posts", ["fetchImportantPosts"]),
    ...mapActions("galleries", ["fetchGalleries"]),
    ...mapActions("links",["fetchLinks"]),
    ...mapActions("loading", ["startLoading", "stopLoading"]),
    async changeUser() {
      if (this.user.full_legal_number != "sin rut") {
        const ln = this.user.full_legal_number;
        localStorage.setItem("view_as", ln);
        try {
          this.startLoading();
          await this.fetchFooterMenu();
          await this.fetchMenuMobile(ln);
          await this.fetchCurrentUser(ln);
          await this.fetchCurrentUserParents(ln);
          this.fetchImportantPosts(ln);
          this.fetchGalleries(ln);
          this.fetchLinks(ln);
          this.fetchUserMessages(ln);
        } catch (error) {
          console.error("Error al cambiar usuario:", error);
        } finally {
          this.stopLoading();
        }
        this.$router.push({ name: "profile" });
      }
    },
    handleCompanyChart() {
      this.showHideCompanyChart()
    }
  },
}
</script>

<style scoped>
.tff-center-item {
  display: flex;
  align-items: center;
}

.email_phone {
  color: #515151;
  text-decoration: inherit;
}

.size-image-avatar {
  height: 150px;
  width: 150px;
}

@media screen and (min-width: 300px) and (max-width: 325px) {
  .size-image-avatar {
    height: 130px;
    width: 130px;
  }
}
</style>